var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHistoryCheck = function SvgIconHistoryCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#05072C",
    d: "m25.5 27.833 2.333-2.333-6.166-6.167v-7.666h-3.334v9zM20 36.667q-3.459 0-6.5-1.313t-5.292-3.562T4.646 26.5Q3.333 23.459 3.333 20t1.313-6.5 3.562-5.292T13.5 4.646q3.041-1.313 6.5-1.313t6.5 1.313q3.042 1.312 5.292 3.562t3.562 5.292 1.313 6.5-1.313 6.5-3.562 5.292-5.292 3.562q-3.041 1.313-6.5 1.313"
  }))));
};
export default SvgIconHistoryCheck;